<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg ">
                <div class="row  justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">Blog</h2>
                        <!--<p class="lead text-white">Whether you want to know more about the games or have some feedback, we're here to help. Something something...</p>-->
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="container justify-content-center">

                <div class="row">
                    <div class="col-md-4">
                        <!--<small class="d-block text-uppercase font-weight-bold mb-4">Image</small>-->
                        <div class="row justify-content-center">
                            <div class="col-sm-9 col-md-12 col-lg-12 col-9">
                                <img v-lazy="'img/brand/blog/demolition-delayed/cat-tastrophy5.png'"  class="img-fluid rounded shadow fixed-size-img">
                            </div>
                        </div>

                    </div>
                    <div class="col-md-8 mt-3">
                        <div class="pl-md-5">
                            <!--<icon name="ni ni-controller" class="mb-5" size="lg" type="warning" shadow rounded></icon>-->
                            <small class="d-block text-info mt-4 text-uppercase font-weight-bold mb-4">{{posts.p4.category}}</small>

                            <h3><router-link to="/demolition-delayed">{{posts.p4.title}}</router-link></h3>
                            <p>{{posts.p4.abstract}}
                                <router-link to="/demolition-delayed">Read more</router-link>
                            </p>
                            <p>by <b>{{posts.p4.author}}</b>, {{posts.p4.datePosted}}</p>
                        </div>
                    </div>
                </div>

                <div class="row mt-5">
                    <div class="col-md-4">
                        <!--<small class="d-block text-uppercase font-weight-bold mb-4">Image</small>-->
                        <div class="row justify-content-center">
                            <div class="col-sm-9 col-md-12 col-lg-12 col-9">
                                <img v-lazy="'img/brand/blog/otc-closing/cyborg2.png'"  class="img-fluid rounded shadow fixed-size-img">
                            </div>
                        </div>

                    </div>
                    <div class="col-md-8 mt-3">
                        <div class="pl-md-5">
                            <!--<icon name="ni ni-controller" class="mb-5" size="lg" type="warning" shadow rounded></icon>-->
                            <small class="d-block text-info mt-4 text-uppercase font-weight-bold mb-4">{{posts.p3.category}}</small>

                            <h3><router-link to="/otc-closing">{{posts.p3.title}}</router-link></h3>
                            <p>{{posts.p3.abstract}}
                                <router-link to="/otc-closing">Read more</router-link>
                            </p>
                            <p>by <b>{{posts.p3.author}}</b>, {{posts.p3.datePosted}}</p>
                        </div>
                    </div>
                </div>
                <div class="row ">
                    <div class="col-md-4">
                        <!--<small class="d-block text-uppercase font-weight-bold mb-4">Image</small>-->
                        <div class="row justify-content-center">
                            <div class="col-sm-9 col-md-12 col-lg-12 col-9">
                                <img v-lazy="'img/brand/blog/otc-reopening/bad.png'"  class="img-fluid rounded shadow fixed-size-img">
                            </div>
                        </div>

                    </div>
                    <div class="col-md-8 mt-3">
                        <div class="pl-md-5">
                            <!--<icon name="ni ni-controller" class="mb-5" size="lg" type="warning" shadow rounded></icon>-->
                            <small class="d-block text-info mt-4 text-uppercase font-weight-bold mb-4">{{posts.p2.category}}</small>

                            <h3><router-link to="/otc-reopening">{{posts.p2.title}}</router-link></h3>
                            <p>{{posts.p2.abstract}}
                                <router-link to="/otc-reopening">Read more</router-link>
                            </p>
                            <p>by <b>{{posts.p2.author}}</b>, {{posts.p2.datePosted}}</p>
                        </div>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-md-4">
                        <!--<small class="d-block text-uppercase font-weight-bold mb-4">Image</small>-->
                        <div class="row justify-content-center">
                            <div class="col-sm-9 col-md-12 col-lg-12 col-9">
                                <img v-lazy="'img/brand/pandas/corona.png'" class="img-fluid rounded shadow fixed-size-img">
                            </div>
                        </div>

                    </div>
                    <div class="col-md-8 mt-3">
                        <div class="pl-md-5">
                            <!--<icon name="ni ni-controller" class="mb-5" size="lg" type="warning" shadow rounded></icon>-->
                            <small class="d-block text-info mt-4 text-uppercase font-weight-bold mb-4">{{posts.p1.category}}</small>

                            <h3><router-link to="/corona-update">{{posts.p1.title}}</router-link></h3>
                            <p>{{posts.p1.abstract}}
                                <router-link to="/corona-update">Read more</router-link>
                            </p>
                            <p>by <b>{{posts.p1.author}}</b>, {{posts.p1.datePosted}}</p>
                        </div>
                    </div>
                </div>
            </div>

        </section>

    </div>
</template>

<script>
    export default {
        name: "Blog",
        data () {
            return {
                posts: {
                    p1: {
                        title: "COVID-19 Update",
                        abstract: "With the ongoing concerns about the COVID-19 outbreak, Off The Couch’s top priority is the safety of our customers and our employees.  To continue the battle against COVID-19,  the Public Health Office and Santa Clara County leadership has extended the Shelter in Place order until the end of May.  Due to this, we will be remaining closed until the shelter is lifted...",
                        datePosted: "May 12, 2020",
                        author: "Nick",
                        category: "announcements"
                    },
                    p2: {
                        title: "Off The Couch is Now Open!",
                        abstract: "Off The Couch is happy to announce that we have re-opened for business!  This also includes the release of our newest games that take place in the world of Pandorum...",
                        datePosted: "June 20, 2020",
                        author: "Nick",
                        category: "announcements"
                    },
                    p3: {
                        title: "Off The Couch is Closing – The Bad, The Ugly, and The Future",
                        abstract: "Some of you may have heard the rumors because I’ve always had a problem keeping my mouth shut.  Either way, it’s true – Off The Couch is closing its doors at the end of this year...",
                        datePosted: "August 20, 2020",
                        author: "Nick",
                        category: "announcements"
                    },
                    p4: {
                        title: "Demolition Delayed!",
                        abstract: "I want to thank everyone for your continued support, goodwill, and positivity during these difficult times. We have some slightly good news, the destruction of our building has been delayed...",
                        datePosted: "February 18, 2021",
                        author: "Nick",
                        category: "announcements"
                    }

                }
            }
        }
    }
</script>

<style scoped>
    .fixed-size-img {
        width: 100%; /* width of container */
        height: 300px; /* height of container */
        object-fit: cover;
    }


</style>
